import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class CollectionItemContext extends BaseOption {
  static label = "Type";

  static userInterfaceComponent = () => {
    return {
      component: inspectorTools.SIMPLE_PICKER,
      props: {
        options: [
          {
            id: "story",
            name: "Stories",
          },
          {
            id: "org",
            name: "Organizations",
          },
          {
            id: "monetization_links",
            name: "Links",
          },
        ],
      },
    };
  };

  static defaultValue = "story";
}
